module.exports = "/assets/data/67e729d91c6a1bd63c46d6c55259e835-GL2.data.json";